/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const OlafMissingSpotMediaDtoTypeEnum = {
    MISSING_SPOT_MEDIA: "MISSING_SPOT_MEDIA"
} as const;

export type OlafMissingSpotMediaDtoTypeEnumKey = (typeof OlafMissingSpotMediaDtoTypeEnum)[keyof typeof OlafMissingSpotMediaDtoTypeEnum];

export type OlafMissingSpotMediaDto = {
    /**
     * @type string
    */
    type: OlafMissingSpotMediaDtoTypeEnumKey;
    /**
     * @type string
    */
    customId: string;
};